<template>
  <div>
    <b-container class="container-box pb-0">
      <b-row class="no-gutters">
        <b-col xl="7" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">
            รายการธุรกรรมใหม่
            {{
              type == "import"
                ? "(นำเข้าข้อมูล)"
                : "Omise ใหม่ (D-Bot, D-Order)"
            }}
          </h1>
        </b-col>
        <b-col
          xl="5"
          class="text-right d-flex justify-content-end align-items-center"
        >
          <a @click="$router.go(-1)">ย้อนกลับ</a>
        </b-col>
      </b-row>
      <div
        class="mt-2 header-purple d-flex justify-content-between align-items-center"
      >
        <p class="mb-0 text-black">
          <strong>ข้อมูลธุรกรรม</strong>
        </p>
        <p class="mb-0">อัพเดทล่าสุด : {{ updatedDate | moment($formatDateTime) }}</p>
      </div>
      <div class="bg-white p-4" v-if="type == 'import'">
        <b-row>
          <b-col sm="6">
            <InputText
              textFloat="หมายเลขธุรกรรม"
              placeholder="หมายเลขธุรกรรม"
              type="text"
              v-model="form.statementNo"
              name="statementNo"
              :isValidate="$v.form.statementNo.$error"
              isRequired
              :v="$v.form.statementNo"
            />
          </b-col>
          <b-col sm="6">
            <label class="font-weight-bold mb-1">
              วัน/เวลา
              <span class="text-danger">*</span>
            </label>
            <div
              :class="[
                'input-container date-box',
                { error: $v.form.date.$error },
              ]"
            >
              <datetime
                type="datetime"
                :input-style="styleDatetime"
                v-model="form.date"
                placeholder="วว/ดด/ปป ชช:มม"
                ref="inputDateTime"
              >
              </datetime>
              <div
                class="icon-container text-right"
                @click="$refs.inputDateTime.isOpen = true"
              >
                <font-awesome-icon icon="calendar-alt" color="#6c64be" />
              </div>
            </div>
            <div v-if="$v.form.date.$error">
              <span class="text-error">กรุณาเลือกวันที่</span>
            </div>
          </b-col>
          <b-col sm="6">
            <InputSelect
              title="ช่องทางการจำหน่าย"
              name="type"
              isRequired
              class="select-type"
              v-model="form.salesChannelId"
              v-bind:options="salesChannelOption"
              valueField="value"
              textField="text"
              @onDataChange="changeSalesChannel"
            />
          </b-col>
          <b-col sm="6">
            <InputSelect
              title="ช่องทางการรับเงิน"
              name="type"
              isRequired
              class="select-type"
              v-model="form.statementPaymentId"
              v-bind:options="statementPaymentOption"
              valueField="value"
              textField="text"
              @onDataChange="changeStatementPayment"
            />
          </b-col>
        </b-row>
      </div>

      <div class="bg-white">
        <hr class="mt-0" v-if="type == 'import'" />
        <FinanceImportPanel
          :form="this.form"
          :v="$v.form"
          v-if="type == 'import'"
        />
        <FinanceOrderPanel
          :form="this.form"
          :v="$v.form"
          v-if="type == 'order'"
        />
      </div>
      <div class="mt-2">
        <div class="p-2 bg-white">
          <b-container class="p-0">
            <b-row class="no-gutters">
              <b-col md="6" class="d-flex">
                <b-button class="grey-btn" @click="$router.go(-1)"
                  >ยกเลิก</b-button
                >
              </b-col>
              <b-col md="6" class="d-flex justify-content-md-end mt-3 mt-md-0">
                <b-button @click="checkForm" class="purple-btn"
                  >บันทึก</b-button
                >
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </b-container>
    <ModalAlert
      ref="modalAlert"
      :text="messageAlert"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="messageError" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import { required, requiredIf } from "vuelidate/lib/validators";
import InputSelect from "@/components/inputs/InputSelect";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import FinanceImportPanel from "./FinanceImportPanel.vue";
import FinanceOrderPanel from "./FinanceOrderPanel.vue";
export default {
  components: {
    InputText,
    InputSelect,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
    FinanceImportPanel,
    FinanceOrderPanel,
  },
  data() {
    return {
      newId: null,
      updatedDate: new Date().toDateString(),
      type: this.$route.query.type,
      form: {
        statementNo: "",
        date: "",
        orderSelectList: [],
        excelFile: "",
        file: "",
        email: "",
        salesChannelId: 1,
        statementPaymentId: 1,
      },
      styleDatetime: {
        width: "180%",
        border: "none",
      },
      messageAlert: "",
      messageError: "",
      salesChannelOption: [],
      statementPaymentOption: [],
    };
  },
  validations() {
    return {
      form: {
        statementNo: {
          required: requiredIf(function() {
            return this.type == "import";
          }),
        },
        date: {
          required: requiredIf(function() {
            return this.type == "import";
          }),
        },
        salesChannelId: {
          required: requiredIf(function() {
            return this.type == "import";
          }),
        },
        statementPaymentId: {
          required: requiredIf(function() {
            return this.type == "import";
          }),
        },
        file: {
          required: requiredIf(function() {
            return this.type == "import";
          }),
        },
        email: {
          required: requiredIf(function() {
            return this.type == "import";
          }),
        },
        orderSelectList: {
          required: requiredIf(function() {
            return this.type == "order";
          }),
        },
        excelFile: "",
      },
    };
  },
  created() {
    this.getFilterList();
  },
  methods: {
    getFilterList() {
      this.axios
        .get(`${this.$baseUrl}/statement/SaleChannelForImport`)
        .then((data) => {
            this.salesChannelOption = data.detail;
            this.form.salesChannelId = data.detail[0].value
            this.axios
              .get(`${this.$baseUrl}/statement/StatementPayment`)
              .then((data) => {
                  this.statementPaymentOption = data.detail;
                  this.form.statementPaymentId = data.detail[0].value
              });
        });
    },
    checkForm() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      this.submitForm();
    },
    submitForm() {
      this.$refs.modalLoading.show();
      if (this.type == "import") {
        var path = "statement/ImportStatement";
        var body = this.form;
      } else {
        var path = "statement/Save";
        var body = { statementOrder: this.form.orderSelectList };
      }
      this.axios.post(`${this.$baseUrl}/${path}`, body).then((data) => {
        this.$refs.modalLoading.hide();
        if (data.result == 1) {
          this.newId = data.detail.statementId;
          this.messageAlert = data.message;
          this.$refs.modalAlert.show();
          setTimeout(() => {
            this.$refs.modalAlert.hide();
          }, 3000);
        } else {
          this.messageError = data.message;
          this.$refs.modalAlertError.show();
        }
      });
    },
    hadleModalAlertClose: function() {
      this.$router.push({ path: `/finance?brandID=${this.$route.query.brandID}` });
    },
    changeSalesChannel(value) {
      this.form.salesChannelId = value;
    },
    changeStatementPayment(value) {
      this.form.statementPaymentId = value;
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #092d53;
}
a:hover {
  color: #8a44c3;
  cursor: pointer;
  text-decoration: underline;
}
::v-deep label {
  font-size: 16px !important;
}
.purple-btn {
  background-color: #8a44c3;
  color: #ffffff;
}
.grey-btn {
  width: 150px;
  background-color: #575757;
  color: #ffffff;
}
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}
.input-container.error {
  border-color: red !important;
}
.icon-container {
  flex: 1 1 auto;
  cursor: text;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.date-box {
  border-radius: 6px;
}
::v-deep .select-type {
  margin-top: 7px !important;
  label {
    margin-bottom: 4px !important;
  }
}
</style>
